/* hs-eslint ignored failing-rules */

/* eslint-disable no-bitwise */
'use es6';

import SeamlessImmutable from 'seamless-immutable';
import { combineReducers } from 'redux';
import { DOMAINS_FETCH } from 'DesignData/actions/ActionTypes';

function fetching(state = false, action) {
  switch (action.type) {
    case DOMAINS_FETCH:
      {
        if (!action.domains & !action.error) {
          return true;
        }

        return false;
      }

    default:
      {
        return state;
      }
  }
}

function byId(state = SeamlessImmutable({}), action) {
  switch (action.type) {
    case DOMAINS_FETCH:
      {
        if (!action.domains) {
          return state;
        }

        action.domains.forEach(domain => {
          state = state.set(domain.domain, SeamlessImmutable(domain));
        });
        return state;
      }

    default:
      return state;
  }
}

export default combineReducers({
  byId,
  fetching
});